module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"nextCalibration":"Next calibration","vrn":"VRN"},"de":{"nextCalibration":"Nächste Kalibrierung","vrn":"Kennzeichen"},"fr":{"nextCalibration":"Prochain étalonnage","vrn":"VRN"},"it":{"nextCalibration":"Prossima calibrazione","vrn":"VRN"}}')
  delete Component.options._Ctor
}
